<template>
  <div 
    class="feedback-card-main ml12 mr12 mb32"
    v-if="showFeedbackCard"
  >
    <!-- CSAT Widget -->
    <template v-if="getFeedbackCardType === 'CSAT' && getNumberOfItems > 0">
      <div class="align-items-center">
        <div class="justify-content-between d-flex pb6 csat-header csat-bottom-border">
          <span class="csat-heading-label fs-16 bold lh20">
            {{ getFeedbackModuleTitle }}
          </span>
          <span @click="closeFeedbackModal()">
            <i class="jfi-close-v2 csat-close"></i>
          </span>
        </div>
        <div class="d-flex mt8 justify-content-between">
          <div class="csat-details mr12 d-flex flex-column">
            <div class="label-csat color-base fs-14 lh18 d-flex mb2">
              <span class="label-item-name medium">
                {{ getPizzaLabel }}
              </span>
            </div>
            <div class="label-csat color-base fs-12 lh18 d-flex mb2">
              <span v-if="getNumberOfItems > 1">
                + {{ getNumberOfItems - 1 }} {{ getNumberOfItems > 2 ? "items" : "item" }}
              </span>
            </div>
            <span class="csat-delivery-label fs-12 lh16 color-slaty">
              {{ getDeliveryDateString }}
            </span>
            <div class="csat-star mt8">
              <i class="jfi-star-outline" v-for="n in 5" @click="updateFeedbackRating(n,'CSAT')"></i>
            </div>
          </div>
          <div :class="{'d-flex': !isToday}">
            <div class="csat-img">
              <img 
                ref="csatImg"
                class="csat-img-container"
                alt="default image"
                :src="`https://images.dominos.co.in/srilanka/cart/${getArrayOfImage[0]}`"
                @error="handleImageError('csatImg')"
              />
              <div 
                v-for="n in getArrayOfImage.length - 1"
                class="csat-img-container csat-img-sqr"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- NPS Widget -->
    <template v-if="getFeedbackCardType === 'NPS'">
      <div class="align-items-center">
        <div class="justify-content-between d-flex mb12 csat-header">
          <span class="csat-heading-label fs-16 bold lh20">
            {{ getFeedbackModuleTitle }}
          </span>
          <span @click="closeFeedbackModal()">
            <i class="jfi-close-v2 csat-close"></i>
          </span>
        </div>
        <div class="nps-rating">
          <div class="d-flex nps-rating-container">
            <span 
              class="nps-rating-scale border-nps pTB10 fs-16 lh20 " 
              v-for="n in 11"
              @click="updateFeedbackRating(n-1, 'NPS')"
            >
              {{ n-1 }}
            </span>
          </div>
          <div class="mt5 d-flex justify-content-between">
            <span class="fs-12 lh18 color-slaty">
              {{ getNpsZeroRatingText }}
            </span>
            <span class="fs-12 lh18 color-slaty">
              {{ getNpsTenRatingText }}
            </span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import PageNames from '../config/pageNames';
import setEvents from '../helpers/events';
import LocalStorageFunc from '../helpers/localStorageFunc';
import {
  keyMapsAction,
  keyMapsMutation
} from '../helpers/storeKeys';
import Utility from '../helpers/utility';
import {
  CSAT_NPS_FEEDBACK_OBJ,
  FEEDBACK_TYPE
} from '../config/CsatNpsFeedback';
import { v2PwaBasePath, staticImgBaseUrl } from '../config/apiEndpoints';
import {
  VWO_CSAT_NPS_EXPERIMENT,
  VWO_CSAT_NPS_EXPERIMENT_VARIANTS
} from '../config/vwoKeys';

export default {
  name: "FeedbackCard",
  components: {},
  data() {
    return {
      isImpressionEventTriggered: false,
      isToday: false,
      staticImgBaseUrl: staticImgBaseUrl
    };
  },
  mounted() {
    if(LocalStorageFunc.isLoggedIn()) {
      this.$store.dispatch(
        keyMapsAction.GET_NPS_CSAT_HOME_WIDGET, {
        mobile: LocalStorageFunc.getUserData()?.userData?.mobile || ''
      });
    }
  },
  methods: {
    closeFeedbackModal() {
      this.eventFunction(true, {
        category: "CSAT rating cancel out"
      },
      "Order_Rating_Cancel"
      );
      this.$store.commit(
        keyMapsMutation.UPDATE_NPS_CSAT_MODAL_FLAG, 
        false
      );
      this.$store.dispatch(
        keyMapsAction.NPS_CSAT_DISMISS_HOME_WIDGET, {
          widgetId: this.$store.state.NpsFeedback.homeWidgetId
        }
      );
    },
    updateFeedbackRating(rating, feedbackType) {
      this.eventFunction(true, {
        rating: rating,
        category: "CSAT home widget",
      },
      "Order_Rating_Widget"
      );
      if (feedbackType === FEEDBACK_TYPE.CSAT) {
        CSAT_NPS_FEEDBACK_OBJ.orderId = this.getOrderId;
        CSAT_NPS_FEEDBACK_OBJ.overall.rating = rating;
      }
      else if (feedbackType === FEEDBACK_TYPE.NPS) {
        CSAT_NPS_FEEDBACK_OBJ.nps.orderId = this.getOrderId;
        CSAT_NPS_FEEDBACK_OBJ.nps.overall.rating = rating;
      }
      localStorage.USER_FEEDBACK = JSON.stringify(CSAT_NPS_FEEDBACK_OBJ);
      this.redirectToFeedbackPage(feedbackType);
    },
    isTimestampOfToday(date) {
      let today = new Date();
      let inputDate = new Date(date);
      if (today.setHours(0, 0, 0, 0) == inputDate.setHours(0, 0, 0, 0)) {
        this.isToday = true;
        return true;
      }
      this.isToday = false;
      return false;
    },
    getDeliveryOrderTypeString(orderType) {
      switch (orderType) {
        case "D":
          return "Delivered";
        case "P":
          return "Take-Away";
        case "DINEIN":
          return "Dine-in";
        default:
          return "Delivered";
      }
    },
    formatAMPM(date) {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0' + minutes : minutes;
      let strTime = hours + ':' + minutes + ' ' + ampm;
      return strTime;
    },
    eventFunction(isClicked = false, eObj = {}, eventName = "") {
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = {
        ...eObj,
        screenName: PageNames.NEXTGEN_HOMEPAGE,
      };
      if(isClicked) {
        preEventObj.rating_type = "Overall Order";
      }
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        undefined,
        undefined,
        preEventObj
      );
      setEvents("amplitude", eventName, eventObj);
    },
    redirectToFeedbackPage(feedbackType) {
      if(
        feedbackType === FEEDBACK_TYPE.CSAT ||
        feedbackType === FEEDBACK_TYPE.NPS
      ) {
        window.location.href =
        v2PwaBasePath +
        '/uf?' +
        `t=${feedbackType}&a=${this.getOrderId}`;
      }
    },
    handleImageError(imageRef) {
      const imageTag = this.$refs[imageRef];
      if(imageTag) {
        imageTag.onError = null;
        imageTag.src = `${staticImgBaseUrl}/images/global/dominos-icon-square.png`;
      }
    }
  },
  computed: {
    showFeedbackCard() {
      const showFeedbackCardFlag = 
        this.$store.state.NpsFeedback.showNpsCsatFeedback && 
        !Utility.checkIfIsMiniApp();
      if(showFeedbackCardFlag && !this.isImpressionEventTriggered) {
        this.isImpressionEventTriggered = true;
        this.eventFunction(
          false,
          {category: this.getFeedbackCardType},
          "CSAT_NPS_Impression"
        );
      }
      return showFeedbackCardFlag;
    },
    getOrderId() {
      return this.$store.state.NpsFeedback.orderId;
    },
    getDeliveryDateString() {
      let _ = "";
      try {
        const deliveryTimestamp = Number(this.$store.state.NpsFeedback.deliveryTimestamp);
        const deliveryOrderType = this.getDeliveryOrderTypeString(this.$store.state.NpsFeedback.deliveryOrderType);
        const date = new Date(deliveryTimestamp);
        _ = deliveryOrderType + ' on ' + date.toDateString().slice(4);
      } catch (err) {
        _ = "";
      }
      return _;
    },
    getNumberOfItems() {
      return this.$store.state.NpsFeedback.items.length;
    },
    getPizzaLabel() {
      return this.$store.state.NpsFeedback.items[0].product.name;
    },
    getPlaceHolderImg(){
      const img =  this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.square;
      const fallBack = staticImgBaseUrl + '/images/global/default-product-img-lg.png'
      return img || fallBack;
    },
    getFeedbackCardType() {
      return this.$store.state.NpsFeedback.type;
    },
    getArrayOfImage() {
      let items = this.$store.state.NpsFeedback.items || [];
      let imgArray = [];
      items.forEach(itm => {
        imgArray.push(itm?.product?.imageUrl);
      });
      return imgArray.slice(0,3);
    },
    isCsatNpsVariant() {
      let vwoExperimentName = LocalStorageFunc.getSessionStorageKey("VWO_PWA_V2_VARIATIONS");
      let exp = vwoExperimentName?.[VWO_CSAT_NPS_EXPERIMENT];
      if(exp === VWO_CSAT_NPS_EXPERIMENT_VARIANTS.CSAT_NPS_VARIANT) {
        return true;
      }
      else {
        return false;
      }
    },
    getFeedbackModuleTitle() {
      return this.$store.state.NpsFeedback.title;
    },
    getNpsZeroRatingText() {
      return this.$store.state.NpsFeedback.npsZeroRating;
    },
    getNpsTenRatingText() {
      return this.$store.state.NpsFeedback.npsTenRating;
    },
  },
}
</script>

<style scoped>
.lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}
.lazy-image-loaded {
  filter: blur(0);
}
</style>
